import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'manufacturers'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getManufacturer (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  turnTimes (id, typeBook) {
    let fs = id ? `manufacturer_id=${id}` : ''
    fs = typeBook ? `${fs}&type_book=${typeBook}` : fs
    return Client.get(`${resource}/manufacturing/turn_times?${fs}`)
      .then(response => response.data)
  }
}
